const PublicationList = () => (
  <ul className="publication-list text-justify">
    <li className="publication-list__item">
      <h3 className="publication-list__title">
      <a href="https://software.intel.com/en-us/download/parallel-universe-magazine-issue-40-april-2020">A New Approach to Parallel Computing Using Automatic Differentiation: Getting Top Performance on Modern Multicore Systems</a>
      </h3>
      <div className="publication-list__author">Authors: Dmitri Goloubentsev, Evgeny Lakshtanov</div>
      <div>Parallel Universe Magazine, (40), 2020</div>
      <div><a href="https://software.intel.com/en-us/download/parallel-universe-magazine-issue-40-april-2020">PUM 40</a></div>
    </li>
    <li className="publication-list__item">
      <h3 className="publication-list__title">
        <a href="https://wilmott.com/aad-breaking-the-primal-barrier/">AAD: Breaking the Primal Barrier</a>
      </h3>
      <div className="publication-list__author">Authors: Dmitri Goloubentsev, Evgeny Lakshtanov</div>
      <div>Wilmott, Year: 2019</div>
      <div><a href="https://github.com/matlogica/aadc-prototype">Source code referenced in the article</a></div>
    </li>
    <li className="publication-list__item">
      <h3 className="publication-list__title">
      <a href="https://arxiv.org/abs/1901.04200">Automatic adjoint differentiation for gradient descent and model calibration.</a>
      </h3>
      <div className="publication-list__author">Authors: Dmitri Goloubentsev, Evgeny Lakshtanov</div>
      <div>International Journal of Wavelets, Multiresolution and Information Processing (2020): 2040004</div>
      <div><a href="https://arxiv.org/abs/1901.04200">arXiv preprint arXiv:1901.04200.</a></div>
    </li>
  </ul>
);

export default PublicationList;